import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const CandidateInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 116px;
  margin-left: 60px;

  ${mediaMaxWidth.tablet`
    padding-top: 60px;
  `}

  ${mediaMaxWidth.smallDesktop`
    margin-left: 0;
    flex-direction: column;
    align-items: center;
  `}
`;

export const Column = styled.div`
  width: 500px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;

  #modalTrigger {
    padding: 20px 30px;
    font-size: 1.3em;
    box-shadow: 0 2px 5px #696969;
  }

  ${mediaMaxWidth.desktop`
    width: 470px;
  `}

  ${mediaMaxWidth.smallDesktop`
    padding: 0 7.5px;
  `}

  ${mediaMaxWidth.phone`
    width: 100vw;
    margin: 0;
  `}
`;

export const CvRow = styled.div`
  display: flex;
  margin-top: 1.25rem;
`;

export const ShareCvButton = styled.button`
  font-size: 1.2rem;
  background: white;
  border: 1px solid;
  border-radius: 4px;
  box-shadow: 0 0 5px rgb(136, 136, 136);
  height: fit-content;
  padding: 1.5px;
  display: flex;
  align-items: flex-end;
  margin-top: 1.7em;
  margin-left: 0.8rem;
`;

export const ShareCvText = styled.div`
  margin-left: 0.1em;
  margin-right: 0.3em;
`;

export const ShareCvIcon = styled.div`
  margin-right: 0.1em;
`;
